import { Typography } from '@mui/material';
import BoschTopBar from '../Header/BoschTopBar';

const LegacyFooter = () => {
    return (
        <footer className="w-full bottom-0 mt-auto">
            <div className="w-full bg-[#E7E7E7]">
                <div className="w-full max-w-screen-xl mx-auto p-4">
                    <div className="flex justify-between items-center">
                        <Typography
                            variant="body2"
                            className="font-Bosch_sans text-[14px] text-[#5F5F5F]"
                        >
                            <span className="text-[15px]">©</span> Robert Bosch GmbH
                        </Typography>
                        <a
                            className="text-[11px] text-[#a1a1a1] hover:text-[#5F5F5F] no-underline"
                            href="https://bgn.bosch.com/FIRSTspiritWeb/wcms/wcms_corpfunc/en/bosch-globalnet/02-organization/corporate-functions/ccm/organization/cisp/topics/data-protection-notice-for-the-bosch-group-employees/data-protection-notice-for-the-bosch-group-employees.html?cmcall=true&perm_link=wcms_corpfunc_-transparency_1-EN"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <Typography
                                variant="body2"
                                className="text-[11px] text-[#a1a1a1] hover:text-[#5F5F5F]"
                            >
                                Data Protection Notice
                            </Typography>
                        </a>
                    </div>
                </div>
            </div>
            <BoschTopBar />
        </footer>
    );
};

export default LegacyFooter;
